import React, { FC } from 'react';
import cx from 'classnames';

import styles from './Steps.scss';

export type StepItem = {
  height?: number;
  imgPng: string;
  imgWebp?: string;
  text: string;
  time: string;
  width?: number;
};

type StepsProps = {
  className?: string;
  config: StepItem[];
};

export const Steps: FC<StepsProps> = ({ className, config }) => (
  <div className={cx(styles.steps, className)}>
    {config.map((item) => {
      const {
        height,
        imgPng,
        imgWebp,
        text,
        time,
        width,
      } = item;

      return (
        <div key={time} className={styles.stepsCard}>
          <picture>
            {imgWebp && <source srcSet={imgWebp} type="image/webp" />}
            <img
              alt={time}
              loading="lazy"
              src={imgPng}
              {...{ height, width }}
            />
          </picture>
          <h3>{time}</h3>
          <p>{text}</p>
        </div>
      );
    })}
  </div>
);
